import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from './IconWithTooltip';

export const DownloadDataIcon = ({ handleClick, ariaLabel, tooltip }) => (
  <IconWithTooltip
    handleClick={handleClick}
    ariaLabel={ariaLabel}
    tooltip={tooltip}
    icon="file-download"
  />
);


DownloadDataIcon.propTypes = {
  handleClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  tooltip: PropTypes.string,
};

DownloadDataIcon.defaultProps = {
  handleClick: undefined,
  ariaLabel: 'download',
  tooltip: 'Download TSV File',
};
